import { render, staticRenderFns } from "./DialogCommunity.vue?vue&type=template&id=7e997abc&scoped=true&"
import script from "./DialogCommunity.vue?vue&type=script&lang=js&"
export * from "./DialogCommunity.vue?vue&type=script&lang=js&"
import style0 from "./DialogCommunity.vue?vue&type=style&index=0&id=7e997abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e997abc",
  null
  
)

export default component.exports